<template>
  <v-dialog
		v-model="dialog"
		persistent
		width="600"
	>
		<v-card>
			<!-- Cabecera del formulario -->
			<v-card-title class="headline">
				<v-flex xs9>
					<v-icon>add</v-icon> Lista de recursos
				</v-flex>
				<v-spacer></v-spacer>
				<v-btn icon @click.native="close()">
					<v-icon>close</v-icon>
				</v-btn>
			</v-card-title>
			<v-card-text>
				<v-container grid-list-md>
					<v-layout wrap>
						<v-flex xs12>
							<h4>Recursos asignados</h4>
							<v-card>
								<v-list>
									<v-list-tile
										v-for="recurso in form.recursos"
										:key="recurso.id"
										avatar
									>
										<v-list-tile-avatar>
											<v-icon>{{ recurso.icono }}</v-icon>
										</v-list-tile-avatar>

										<v-list-tile-content>
											<v-list-tile-title>{{ recurso.descripcion }}</v-list-tile-title>
										</v-list-tile-content>

										<v-list-tile-action>
											<v-btn
												icon
												@click="borrarRecurso(recurso.id)"
											>
												<v-icon color="error">delete</v-icon>
											</v-btn>
										</v-list-tile-action>
									</v-list-tile>
								</v-list>
							</v-card>
							<h4>Recursos disponibles</h4>
							<v-card>
								<v-list>
									<v-list-tile
										v-for="recurso in recursos"
										:key="recurso.id"
										avatar
									>
										<v-list-tile-avatar>
											<v-icon>{{ recurso.icono }}</v-icon>
										</v-list-tile-avatar>

										<v-list-tile-content>
											<v-list-tile-title>{{ recurso.descripcion }}</v-list-tile-title>
										</v-list-tile-content>

										<v-list-tile-action>
											<v-btn
												icon
												@click="agregarRecurso(recurso)"
											>
												<v-icon color="success">add</v-icon>
											</v-btn>
										</v-list-tile-action>
									</v-list-tile>
								</v-list>
							</v-card>
						</v-flex>
					</v-layout>
				</v-container>
			</v-card-text>
			<v-card-actions>
				<v-spacer></v-spacer>
				<v-btn
					@click.native="close()">
					<v-icon>cancel</v-icon> {{$t('common.cancel') }}
				</v-btn>
				<v-btn
					color="primary"
					@click="save()"
					:loading="loading">
					<v-icon dark>check</v-icon> {{$t('common.save') }}
				</v-btn>
			</v-card-actions>
		</v-card>
	</v-dialog>
</template>

<script>
import validate from '@/common/mixins/validate'; // Importación de mixin de validaciones

export default {
	// Definición de mixins importados
	mixins: [validate],
	// Variables iniciales
	data () {
		return {
			dialog: false,
			form: {},
			valid: false,
			loading: false,
			recursos: []
		}
	},
	mounted () {
		this.obtenerRecursos()
		this.$bus.$on('openDialogVerAsignarRecursos', item => {
			this.form = item
			this.dialog = true
		})
	},
	methods: {
		agregarRecurso (recurso) {
			let find = false
			this.form.recursos.forEach(elem => {
				if (elem.id == recurso.id) {
					this.$message.error('El recurso ya fue agregado al Rol')
					find = true
				}
			})
			if (!find) {
				this.form.recursos.push(recurso)
				this.$message.success('Recurso agregado al Rol')
			}
		},
		borrarRecurso (id) {
			for (let i = 0; i < this.form.recursos.length; i++) {
				if (this.form.recursos[i].id == id) {
					this.form.recursos.splice(i, 1)
					break
				}
			}
		},
		async obtenerRecursos () {
			try {
				let res = await this.$service.graphql({
					query: `
						query {
							recursos {
								rows {
									id
									descripcion
									icono
								}
							}
						}
					`
				})
				this.recursos = res.recursos.rows
			} catch (e) {
				console.log(e)
			}
		},
		close () {
			this.form = {},
			this.loading = false
			this.valid = false
			this.$bus.$emit('closeDialog')
			this.dialog = false
		},
		async save () {
			let data = {
				id: this.form.id,
				recursos: this.form.recursos
			}
			this.loading = true
			try {
				await this.$service.graphql({
					query: `
						mutation agregar($recursos: AddRecursos!){
							rolAddRecursos(recursos: $recursos){
								respuesta
							}
						}
					`,
					variables: {
						recursos: data
					}
				})
				this.$message.success();
				this.close()
			} catch (error) {
				console.log(error)
			}
			this.loading = false
		}
	}
}
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/components/admin/rol-recurso/dialogs/VerAsignarRecursos.vue